export const productosEtiquetado = [
    {
        id: 506,
        categoria: 'etiquetado',
        nombre: 'PATAS ARTICULADAS ',
        descripcion: 'Estabilidad, autoalineación y seguridad para plataformas de pesaje. ',
        descripcion2: 'Estabilidad, autoalineación y seguridad para plataformas de pesaje. Nuestras patas articuladas optimizan el desempeño de las celdas de carga al compensar desalineaciones, absorber vibraciones y distribuir mejor los esfuerzos. Son el complemento ideal para básculas de plataforma, aumentando la repetibilidad y prolongando la vida útil del sistema. ',
        imagen: '/imagenes/productos/Repuestos/ppatas1.webp',
        caracteristicas: [
          {
            titulo: 'Características y beneficios',
            items: [
                'Cabeza esférica autoalineante: compensa desniveles y dilataciones de la estructura, minimizando cargas laterales en la celda. ',
                'Ajuste de altura (roscado) para nivelación fina de la plataforma. ',
                'Base antivibración/antideslizante con elastómero (según modelo) que reduce ruido mecánico y mejora la estabilidad de lectura. ',
                'Diseño antilevantamiento y antirotación opcional para mayor seguridad en uso industrial. ',
                'Materiales: acero galvanizado para uso general o acero inoxidable AISI 304/316 para ambientes agresivos y sanitarios. ',
            ]
          }
        ],
        opciones: [
          {
            id: 'patas-articuladas',
            nombre: 'PATAS ARTICULADAS ',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Repuestos/ppatas1.webp',
          '/imagenes/productos/Repuestos/ppatas2.webp',
          '/imagenes/productos/Repuestos/ppatas3.webp',

        ]
      },
      {
        id: 507,
        categoria: 'etiquetado',
        nombre: 'CAJAS SUMADORAS',
        descripcion: 'Balanceo preciso, instalación limpia y máxima estabilidad en sistemas multiapoyo.',
        descripcion2: ' Las cajas sumadoras analógicas agrupan la señal de 4, 6 ,8 y 10 celdas de carga y permiten realizar el balanceo de esquinas (excentricidad) para que la báscula entregue la misma lectura sin importar el punto de apoyo. Son el corazón de plataformas camioneras, tolvas y balanzas industriales de alto desempeño.',
        imagen: '/imagenes/productos/Repuestos/csumadoras1.webp',
        caracteristicas: [
          {
            titulo: 'Características y beneficios',
            items: [
                'Entradas múltiples (4–10 celdas) con borneras sobredimensionadas y etiquetado claro para una instalación rápida y segura. ',
                'Ajuste individual por celda mediante potenciómetros multiturno  que facilitan una calibración fina y repetible. ',
                'Compatibles con cableado 4/6 hilos (excitación) para compensar caídas de tensión y mejorar la precisión. ',       
                'Construcción robusta: cajas en acero inoxidable o ABS con junta perimetral, prensaestopas IP68 y tornillería inoxidable. ',
                'Mantenimiento sencillo: puntos de test para medición de cada celda, puentes de aislamiento para diagnóstico y espacio para gestión de cableado. ',
            ]
          }
        ],
        opciones: [
          {
            id: 'cajas-sumadoras',
            nombre: 'CAJAS SUMADORAS',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Repuestos/csumadoras1.webp',
          '/imagenes/productos/Repuestos/csumadoras2.webp',
          '/imagenes/productos/Repuestos/csumadoras3.webp',
          '/imagenes/productos/Repuestos/csumadoras4.webp',
          '/imagenes/productos/Repuestos/csumadoras5.webp',
        ]
      },
      {
        id: 508,
        categoria: 'etiquetado',
        nombre: 'REPETIDORES DE PESO',
        descripcion: 'Visibilidad a distancia y control seguro del proceso.',
        descripcion2: 'Visibilidad a distancia y control seguro del proceso. Los repetidores de peso muestran la lectura de la báscula en puntos estratégicos de la planta para que operadores y conductores vean el valor en tiempo real sin acercarse al indicador principal. Mejoran la seguridad, reducen errores de comunicación y aceleran las maniobras de carga/descarga. ',
        imagen: '/imagenes/productos/Repuestos/rpeso1.webp',
        caracteristicas: [
          {
            titulo: 'Características ',
            items: [
                'Alta visibilidad: dígitos LED de gran tamaño (p. ej., 57–120 mm) con lectura a larga distancia y excelente contraste en interior/exterior. ',
                'Construcción industrial: gabinetes en acero inoxidable o metálicos con IP65–IP66 (según modelo) para polvo, humedad y lavado. ',
                'Sincronización en tiempo real con el indicador principal para evitar desfases y lecturas ambiguas. ',
            ]
          },
          {
            titulo : 'Interfaces de conexión',
            items: [
                'Serial (RS-232/RS-485) ',
                'Opciones inalámbricas (radio/Wi-Fi) para zonas sin cableado. ',
            ]
          }
        ],
        opciones: [
          {
            id: 'repetidores-peso',
            nombre: 'REPETIDORES DE PESO',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Repuestos/rpeso1.webp',
          '/imagenes/productos/Repuestos/rpeso2.webp',
        ]
      },
      {
        id: 509,
        categoria: 'etiquetado',
        nombre: 'BATERÍAS',
        descripcion: 'En Servibalanzas contamos con baterías de repuesto para indicadores de peso en los formatos más usados en la industria',
        descripcion2: 'En Servibalanzas contamos con baterías de repuesto para indicadores de peso en los formatos más usados en la industria. Ofrecemos baterías de 12 V y 24 V, con capacidades desde 1.000 mAh hasta 10.000 mAh, según el modelo de indicador. Son ideales para sistemas de pesaje en movimiento, donde el cableado no es una opción viable. ',
        imagen: '/imagenes/productos/Repuestos/bbaterias1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                'Tecnología sellada : libres de mantenimiento y de derrames. ',
                'Alta confiabilidad: baja autodescarga y buen desempeño en ciclos frecuentes. ',
                'Compatibilidad con la mayoría de indicadores de pesaje portátiles (consultar modelo). ',
                
                'Terminales estándar (según versión) para un reemplazo rápido y seguro. ',
                'Opciones de carga: cargadores 110/220 V  ',
                'Soporte Servibalanzas: verificación de compatibilidad, instalación y retiro/reciclaje de baterías usadas. ',
            ]
          }
        ],
        opciones: [
          {
            id: 'baterias',
            nombre: 'BATERÍAS',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Repuestos/bbaterias1.webp',
          '/imagenes/productos/Repuestos/bbaterias2.webp',
          '/imagenes/productos/Repuestos/bbaterias3.webp',
          '/imagenes/productos/Repuestos/bbaterias4.webp',
        ]
      },
      {
        id: 510,
        categoria: 'etiquetado',
        nombre: 'FUENTES DE PODER',
        descripcion: 'En Servibalanzas contamos con fuentes de poder para indicadores en las tensiones más usadas en la industria: 5 V, 9 V, 12 V y 24 V DC . Soluciones confiables para operación continua en terreno ',
        descripcion2: 'En Servibalanzas contamos con fuentes de poder para indicadores en las tensiones más usadas en la industria: 5 V, 9 V, 12 V y 24 V DC . Soluciones confiables para operación continua en terreno. ',
        imagen: '/imagenes/productos/Repuestos/ffuentes1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                'Amplio rango de entrada: 100–240 VAC, 50/60 Hz. ',
                'Formatos disponibles: adaptador de pared, sobremesa, riel DIN ',
                'Estabilidad y bajo rizado, ideales para electrónica de pesaje. ',
                'Eficiencia alta (conmutadas), menor calentamiento y mayor vida útil. ',
                'Conectividad: plug DC 2.1/2.5 mm,  cables a medida y polaridad garantizada. ',
                'Certificaciones típicas: CE/UL/FCC (según modelo) ',
            ]
          }
        ],
        opciones: [
          {
            id: 'fuentes-de-poder',
            nombre: 'FUENTES DE PODER',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Repuestos/ffuentes1.webp',
          '/imagenes/productos/Repuestos/ffuentes2.webp',
          '/imagenes/productos/Repuestos/ffuentes3.webp',
          '/imagenes/productos/Repuestos/ffuentes4.webp',
          '/imagenes/productos/Repuestos/ffuentes5.webp',

        ]
      },
      {
        id: 511,
        categoria: 'etiquetado',
        nombre: 'CABLE DE CELDA Y CONTROL',
        descripcion: 'Cable de celda y cable de control diseñados para plataformas y basculas camioneras, con blindaje anti-EMI/RFI, baja capacitancia y cubierta para intemperie. Soluciones robustas para instalaciones nuevas o retrofit. ',
        descripcion2: 'Cable de celda y cable de control diseñados para plataformas y basculas camioneras, con blindaje anti-EMI/RFI, baja capacitancia y cubierta para intemperie. Soluciones robustas para instalaciones nuevas o retrofit. ',
        imagen: '/imagenes/productos/Repuestos/ccable1.webp',
        caracteristicas: [
          {
            titulo: 'Características y beneficios',
            items: [
                'Conductores de cobre estañado trenzado ',
                'Esquema típico: +Exc, –Exc, +Sig, –Sig, +Sense, –Sense (mantiene precisión en tramos largos compensando caídas de tensión). ',
                'Baja capacitancia para mayor estabilidad de lectura. ',
                'Cubiertas PVC/PUR/PE ',
                'Suministro a metraje, kits pre-terminados y rotulados. ',
                
            ]
          }
        ],
        opciones: [
          {
            id: 'cable-de-celda-y-control',
            nombre: 'CABLE DE CELDA Y CONTROL',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Repuestos/ccable1.webp',
          '/imagenes/productos/Repuestos/ccable2.webp',
          '/imagenes/productos/Repuestos/ccable3.webp',


        ]
      },

      {
        id: 512,
        categoria: 'etiquetado',
        nombre: 'SERIAL A ETHERNET',
        descripcion: 'es un serial device server industrial que conecta equipos RS-232/RS-422/RS-485 a redes Ethernet 10/100, permitiendo administrar dispositivos serie a distancia sin cambiar la instalación existente. Está pensado para ambientes exigentes y monta en riel DIN o muro.',
        descripcion2: 'es un serial device server industrial que conecta equipos RS-232/RS-422/RS-485 a redes Ethernet 10/100, permitiendo administrar dispositivos serie a distancia sin cambiar la instalación existente. Está pensado para ambientes exigentes y monta en riel DIN o muro.',
        imagen: '/imagenes/productos/Repuestos/sethernet1.webp',
        caracteristicas: [
          {
            titulo: 'Características y beneficios',
            items: [
                'Puertos: 1× RJ45 10/100BASE-TX + 1× RS-232 (DB9) y 1× RS-422/RS-485 (bornera 4 pines). Velocidad serie hasta 921.6 kbps.  ',
                'Modos de operación: TCP Server/Client, UDP, Virtual COM/RFC2217, Pair Connection, Serial Telnet y Modbus converter (server/cliente).  ',
                'Alimentación redundante: 9–48 VDC / 24 VAC con failover por hardware; bornera extraíble. ',
            ]
          }
        ],
        opciones: [
          {
            id: 'serial-a-ethernet',
            nombre: 'SERIAL A ETHERNET',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Repuestos/sethernet1.webp',
          '/imagenes/productos/Repuestos/sethernet2.webp',


        ]
      },

      {
        id: 513,
        categoria: 'etiquetado',
        nombre: 'SERIAL A WIFI',
        descripcion: 'Conecta tus equipos de pesaje a la red inalámbrica sin cambiar la instalación. Este serial device server Wi-Fi permite integrar indicadores de peso, PLC y periféricos RS-232/RS-422/RS-485 a la red inalámbrica de la planta, habilitando monitoreo y control remoto con alta confiabilidad y seguridad. ',
        descripcion2: 'Conecta tus equipos de pesaje a la red inalámbrica sin cambiar la instalación. Este serial device server Wi-Fi permite integrar indicadores de peso, PLC y periféricos RS-232/RS-422/RS-485 a la red inalámbrica de la planta, habilitando monitoreo y control remoto con alta confiabilidad y seguridad. ',
        imagen: '/imagenes/productos/Repuestos/swifi1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                'Cableado reducido y mayor movilidad de equipos. ',
                'Acceso remoto a indicadores y controladores de pesaje desde SCADA/ERP. ',
                'Menos paradas: diagnósticos y mantenimiento sin ir a terreno. ',
                'Escalabilidad: integra nuevas básculas sin tender cables largos. ',
            ]
          }
        ],
        opciones: [
          {
            id: 'serial-a-wifi',
            nombre: 'SERIAL A WIFI',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Repuestos/swifi1.webp',
          '/imagenes/productos/Repuestos/swifi2.webp',
          '/imagenes/productos/Repuestos/swifi3.webp',


        ]
      },
      {
        id: 514,
        categoria: 'etiquetado',
        nombre: 'PANELES FRONTALES',
        descripcion: 'Reemplazamos frentes originales en mal estado por paneles nuevos de calce exacto, recuperando la estanqueidad, la legibilidad y la imagen del equipo  ',
        descripcion2: 'Reemplazamos frentes originales en mal estado por paneles nuevos de calce exacto, recuperando la estanqueidad, la legibilidad y la imagen del equipo  ',
        imagen: '/imagenes/productos/Repuestos/pfrontales1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
                'Compatibilidad exacta: fabricamos según marca/modelo  ',
                'Sellado: juntas y adhesivos 3M, manteniendo la protección del indicador.  ',
                'Restituye la estanqueidad e higiene del equipo  ',
                
                'Mejora la lectura y usabilidad, prolongando la vida útil del indicador.  ',
                'Imagen profesional y homogénea en toda la planta.  ',
                
                'Alternativa rápida y económica frente al cambio completo del instrumento.  ',
            ]
          }
        ],
        opciones: [
          {
            id: 'paneles-frontales',
            nombre: 'PANELES FRONTALES',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Repuestos/pfrontales1.webp',

        ]
      },
      {
        id: 515,
        categoria: 'etiquetado',
        nombre: 'MONTAJE PARA ESTANQUES ',
        descripcion: 'Sistema de módulos de pesaje para estanques/silos que garantiza mediciones estables incluso con vibración, dilataciones térmicas o cargas laterales. ',
        descripcion2: 'Sistema de módulos de pesaje para estanques/silos que garantiza mediciones estables incluso con vibración, dilataciones térmicas o cargas laterales. Cada módulo integra celda de carga y kit de montaje con elementos de seguridad (anti-levantamiento y topes laterales). Ideal para control de inventario, formulación y dosificación en alimentos, químicos, minería y agro.',
        imagen: '/imagenes/productos/Repuestos/montaestanque1.webp',
        caracteristicas: [
          {
            titulo: 'Características',
            items: [
              '•	Rango de capacidades por punto: 1 t, 3 t, 5 t, 10 t, 20 t.',
              '•	Diseño auto-alineante (pendular / copa-oscilante) para absorber desalineaciones y dilataciones del estanque.',
              '•	Conjunto de seguridad: anti-levantamiento, restricción lateral y bloqueo de instalación (para izaje/ajuste).',
              '•	Materiales: acero inoxidable (celda) y bases galvanizadas o inox (según versión).',
              '•	Protección ambiental: IP68/IP69K (celda); módulos sellados para uso industrial.',
              '•	Exactitud metrológica: clase OIML R60 C3 típica (hasta 0,02 % FS).',
              '•	Salida estándar: 2,0 mV/V (compatibles con indicadores/controladores universales).',
              '•	Interconexión: 4–6 hilos, caja sumadora con ajuste de esquinas (corner trimming).',
              '•	Aplicaciones: estanques de almacenamiento, tolvas, reactores, mezcladores, silos y big-bags.',
              
            ]
          }
        ],
        opciones: [
          {
            id: 'montage-para-estanques',
            nombre: 'MONTAJE PARA ESTANQUES ',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Repuestos/montaestanque1.webp',
          '/imagenes/productos/Repuestos/montaestanque2.webp',

        ]
      },
      {
        id: 516,
        categoria: 'etiquetado',
        nombre: 'USB A RS-232 CON PROTECCION ',
        descripcion: 'Cable adaptador serie USB a RS232 industrial, adopta el chip FT232RL original, proporciona una comunicación estable, una opción ideal para equipos de control industrial y / o aplicaciones con altos requisitos de comunicación.',
        descripcion2: 'Cable adaptador serie USB a RS232 industrial, adopta el chip FT232RL original, proporciona una comunicación estable, una opción ideal para equipos de control industrial y / o aplicaciones con altos requisitos de comunicación.',
        imagen: '/imagenes/productos/Repuestos/usbrs1.webp',
        tablaEspecificaciones: {
          titulo: 'Especificaciones Técnicas - USB RS-232 CON PROTECCION',
          columnas: ['Especificación', 'Descripción'],
          filas: [
            {
              categoria: 'Tipos',
              valores: ['Cable adaptador serie USB a RS232 DB9'],
              spanAll: true
            },
            {
              categoria: 'Chip',
              valores: ['Chip FT232RL original FTDI'],
              spanAll: true
            },
            {
              categoria :'Interfaz de host',
              valores: ['Interfaz USB tipo A'],
              spanAll: true
            },
            {
              categoria: 'Velocidad de datos',
              valores: ['300 bps ~ 921600 bps'],
              spanAll: true
            },
    
            {
              categoria: 'Peso Pan (MM)',
              valores: ['334 * 245 (Inoxidable Acero)'],
              spanAll: true
            },
            {
              categoria :'Interfaz del dispositivo',
              valores: ['Cable USB-TO-RS232-Macho: Puertomacho RS232 DB9 Cable USB-TO-RS232-Hembra: Puerto RS232 DB9 hembra'],
              spanAll: true
            },
            {
              categoria: 'Especificación del cable',
              valores: ['Negro, funda de PVC, longitud total 1,5 m'],
              spanAll: true
            }
          ]
        },
        caracteristicas: [
          { 
            titulo: 'Características',
            items: [
              '•	Chip FT232RL original FTDI para máxima compatibilidad y estabilidad.',
              '•	Comunicación estable con velocidades de 300 bps a 921600 bps.',
              '•	Interfaz USB tipo A para conexión universal a equipos industriales.',
              '•	Protección contra interferencias electromagnéticas (EMI).',
              '•	Cable de alta calidad con funda de PVC negro, longitud de 1.5 metros.',
              '•	Opciones de conector macho y hembra DB9 para diferentes aplicaciones.',
              '•	Ideal para equipos de control industrial y aplicaciones con altos requisitos de comunicación.',
              '•	Certificación industrial para operación en entornos exigentes.',
            ]
          } 
        ],
        opciones: [
          {
            id: 'usb-a-rs-232-con-proteccion',
            nombre: 'USB A RS-232 CON PROTECCION',
            
          },
        ],
        imagenes: [
          '/imagenes/productos/Repuestos/usbrs1.webp',
          '/imagenes/productos/Repuestos/usbrs2.webp',
          '/imagenes/productos/Repuestos/usbrs3.webp',
          '/imagenes/productos/Repuestos/usbrs4.webp',

        ]
      }
]; 
